import { Suspense, useEffect, useState } from 'react'
import {
    Await,
    defer,
    Link,
    useLoaderData
} from 'react-router-dom'
import { vr } from '../util/api'
import Heading from './helper/Heading'
import Iframe from './helper/Iframe'
import LoadingSpinner from './components/LoadingSpinner'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/TourDetails.module.scss'

export const loader = async ({ params }) => {
    console.log(params.vrId)
    return defer({ vr: vr(params.vrId) })
}

export default function TourDetails() {
    const [loaderData, setLoaderData] = useState(useLoaderData())

    useEffect(() => {
        document.querySelector('header span').innerText = 'تور مجازی'
    }, [])

    return (
        <section className={styles.vr}>
            <div className='__frame' data-width={`large`}>
                <Suspense fallback={<LoadingSpinner />}>
                    <Await
                        resolve={loaderData.vr}
                        errorElement={<>error</>}>
                        {(data) => {
                            console.log(data)
                            return (
                                data.map((item) => {
                                    Title(item.title)
                                    return <>
                                        <Link to={`../`} >بازگشت</Link>
                                        <Heading name={item.title} />
                                        <Iframe url={item.url} />
                                        <br />
                                        <Heading name={`توضیحات`} />
                                        <div className={styles.lead}>{item.lead}</div>
                                        <Heading name={`به راحتی مسیریابی کنید`} />
                                        <Iframe url={item.location} properties={{ height: '200px' }} title="مشاهده «شهرداری اردبیل» روی نقشه بلد" />
                                    </>
                                })
                            )
                        }}
                    </Await>
                </Suspense>
            </div>
        </section>
    )
}